import React from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminApps from '../components/admin/AdminApps';
import AdminUsers from '../components/admin/AdminUsers';
import AdminGroups from '../components/admin/AdminGroups';
import AdminDashboard from '../components/admin/AdminDashboard';
import Logo from '../components/Logo';

export default function AdminPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  // Voir PortalPage : on navigue tout de suite, sans attendre un cycle de rendu.
  const seDeconnecter = () => { logout(); navigate('/login', { replace: true }); };

  const navStyle = (active) => ({
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '10px 16px', borderRadius: 8,
    color: active ? '#fff' : 'rgba(255,255,255,0.65)',
    background: active ? 'rgba(255,255,255,0.15)' : 'transparent',
    fontWeight: active ? 600 : 400, fontSize: 14, textDecoration: 'none',
    transition: 'all 0.2s',
  });

  return (
    <div style={styles.wrapper}>
      {/* Sidebar */}
      <aside style={styles.sidebar}>
        <div style={styles.sidebarHeader}>
          <Logo size={44} />
          <div>
            <div style={styles.sidebarTitle}>Administration</div>
            <div style={styles.sidebarSub}>Portail Entreprise</div>
          </div>
        </div>
        <nav style={styles.nav}>
          <NavLink to="/admin" end style={({ isActive }) => navStyle(isActive)}>
            📊 Tableau de bord
          </NavLink>
          <NavLink to="/admin/applications" style={({ isActive }) => navStyle(isActive)}>
            🔷 Applications
          </NavLink>
          <NavLink to="/admin/users" style={({ isActive }) => navStyle(isActive)}>
            👥 Utilisateurs
          </NavLink>
          <NavLink to="/admin/groups" style={({ isActive }) => navStyle(isActive)}>
            📁 Groupes
          </NavLink>
        </nav>
        <div style={styles.sidebarFooter}>
          <button onClick={() => navigate('/')} style={styles.backBtn}>← Retour au portail</button>
          <button onClick={seDeconnecter} style={styles.logoutBtn}>Déconnexion</button>
        </div>
      </aside>

      {/* Contenu */}
      <main style={styles.main}>
        <Routes>
          <Route index element={<AdminDashboard />} />
          <Route path="applications" element={<AdminApps />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="groups" element={<AdminGroups />} />
        </Routes>
      </main>
    </div>
  );
}

const styles = {
  wrapper: { display: 'flex', minHeight: '100vh' },
  sidebar: { width: 240, background: '#062259', display: 'flex', flexDirection: 'column', padding: '24px 16px', flexShrink: 0 },
  sidebarHeader: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 32, color: '#fff' },
  sidebarTitle: { fontSize: 16, fontWeight: 700, color: '#fff' },
  sidebarSub: { fontSize: 11, color: 'rgba(255,255,255,0.5)' },
  nav: { display: 'flex', flexDirection: 'column', gap: 4, flex: 1 },
  sidebarFooter: { display: 'flex', flexDirection: 'column', gap: 8, marginTop: 24 },
  backBtn: { background: 'transparent', color: 'rgba(255,255,255,0.65)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 8, padding: '8px 12px', fontSize: 13, cursor: 'pointer', textAlign: 'left' },
  logoutBtn: { background: '#E46138', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 12px', fontSize: 13, cursor: 'pointer' },
  main: { flex: 1, background: '#f4f6f9', padding: 32, overflow: 'auto' },
};
